import { useNavigate } from 'react-router-dom';
import '../../css/shared/MatchCard.css';
import FavStar from './FavStar';

/* derive a stable favorite item from the match, using href (/match/{sport}/{id}) when present */
function favItemFor(match) {
  const name = `${match.home} - ${match.away}`;
  const parts = typeof match.href === 'string' ? match.href.split('/') : [];
  const sport = match.sport || (parts[1] === 'match' ? parts[2] : undefined);
  return {
    id: match.href || `${match.home}|${match.away}`,
    type: 'match',
    name,
    meta: match.league || match.status || '',
    sport,
    matchId: parts[1] === 'match' ? parts[3] : undefined,
    href: match.href,
  };
}

function OddsCell({ value, trend, locked }) {
  if (locked) {
    return (
      <div className="odds-cell">
        <svg className="odds-lock" viewBox="0 0 14 16" fill="none">
          <rect x="1.5" y="6.5" width="11" height="8" rx="2" stroke="#757490" strokeWidth="1.3" />
          <path d="M4 6.5V4.5a3 3 0 016 0v2" stroke="#757490" strokeWidth="1.3" />
        </svg>
      </div>
    );
  }
  const empty = value === '0' || value === '-' || value == null;
  return (
    <div className={'odds-cell' + (empty ? ' is-empty' : '')}>
      <span className="odds-val">{value == null ? '-' : value}</span>
      {trend ? <span className={'odds-trend ' + trend} /> : null}
    </div>
  );
}

export default function MatchCard({ match }) {
  const navigate = useNavigate();
  const hasScore = match.homeScore != null;

  const handleTeamClick = () => {
    if (match.href) navigate(match.href);
    else navigate('/match/1');
  };

  return (
    <article className="matchcard">
      <div className="matchcard-market">
        <div
          className="matchcard-teams"
          onClick={handleTeamClick}
          style={{ cursor: 'pointer' }}
        >
          <div className="matchcard-teamrow">
            <span className="matchcard-team">{match.home}</span>
            {hasScore ? <span className="matchcard-score">{match.homeScore}</span> : null}
          </div>
          <div className="matchcard-teamrow">
            <span className="matchcard-team">{match.away}</span>
            {hasScore ? <span className="matchcard-score">{match.awayScore}</span> : null}
          </div>
        </div>
        <div className="matchcard-odds">
          {match.odds.map((o, i) => (
            <OddsCell key={i} value={o.v} trend={o.trend} locked={o.locked} />
          ))}
        </div>
      </div>
      <div className="matchcard-info">
        {match.live ? (
          <span className="matchcard-live" />
        ) : (
          <svg width="11" height="11" viewBox="0 0 12 12" fill="none">
            <circle cx="6" cy="6" r="5" stroke="#757490" strokeWidth="1.1" />
            <path d="M6 3.2V6l2 1.3" stroke="#757490" strokeWidth="1.1" strokeLinecap="round" />
          </svg>
        )}
        <span className="matchcard-status">{match.status}</span>
        {match.extra ? <span className="matchcard-extra">{match.extra}</span> : null}
        <FavStar item={favItemFor(match)} size={13} className="matchcard-fav" />
      </div>
    </article>
  );
}
